/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   MIN QUANTITY ENFORCEMENT — tag min-qty-{n}
   Forces minimum quantity on product page and validates cart.
   ============================================================ */
(function() {
  'use strict';

  // Parse min-qty tag from product page body class or meta
  function getMinQtyFromTags() {
    // The product tags are available via the data attribute we inject in the Liquid
    var el = document.querySelector('[data-min-qty]');
    if (el) return parseInt(el.getAttribute('data-min-qty'), 10) || 0;
    return 0;
  }

  // === PRODUCT PAGE: enforce min on quantity input ===
  function enforceProductMinQty() {
    var minQty = getMinQtyFromTags();
    if (minQty <= 1) return;

    var qtyInput = document.querySelector('.quantity-selector--product input[type="number"]');
    if (!qtyInput) return;

    qtyInput.setAttribute('min', minQty);
    qtyInput.setAttribute('step', '1');
    if (parseInt(qtyInput.value, 10) < minQty) {
      qtyInput.value = minQty;
    }

    // Show notice near quantity
    var wrapper = qtyInput.closest('.product-form__quantity-with-rules');
    if (wrapper && !wrapper.querySelector('.min-qty-notice')) {
      var notice = document.createElement('p');
      notice.className = 'min-qty-notice';
      notice.style.cssText = 'color:#856404;font-size:13px;margin-top:6px;font-weight:500;';
      notice.textContent = 'Minimum ' + (minQty * 100) + ' jetons (' + minQty + ' lots de 100)';
      wrapper.appendChild(notice);
    }

    // Intercept decrease button
    qtyInput.addEventListener('change', function() {
      if (parseInt(this.value, 10) < minQty) {
        this.value = minQty;
      }
    });
  }

  // === ADD TO CART: validate before submission ===
  function interceptAddToCart() {
    var minQty = getMinQtyFromTags();
    if (minQty <= 1) return;

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.matches || !form.matches('.product-form')) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      var qty = parseInt(qtyInput.value, 10);
      if (qty < minQty) {
        e.preventDefault();
        e.stopPropagation();
        alert('Commande minimum : ' + (minQty * 100) + ' jetons (' + minQty + ' lots de 100).\nVeuillez sélectionner au moins ' + minQty + ' lots.');
        qtyInput.value = minQty;
        qtyInput.focus();
        return false;
      }
    }, true);
  }

  // === CART PAGE: validate quantities and warn ===
  function validateCart() {
    // Cart validation runs on /cart page
    if (window.location.pathname !== '/cart') return;

    var checkoutBtn = document.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;

    checkoutBtn.closest('form').addEventListener('submit', function(e) {
      // Fetch cart data to check min quantities
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var violations = [];
          cart.items.forEach(function(item) {
            // Check if product has min-qty tag
            // We check by looking at the product handle — items with "jeton" and "lot-de-100" in handle
            if (item.properties && item.properties._min_qty) {
              var min = parseInt(item.properties._min_qty, 10);
              if (item.quantity < min) {
                violations.push(item.title + ' : minimum ' + min + ' lots');
              }
            }
          });
          if (violations.length > 0) {
            alert('Quantité insuffisante :\n' + violations.join('\n'));
          }
        });
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enforceProductMinQty();
      interceptAddToCart();
      validateCart();
    });
  } else {
    enforceProductMinQty();
    interceptAddToCart();
    validateCart();
  }
})();


/* ============================================================
   FIX SMART FILTER — pagination AJAX (2026-03-29)
   Smart Filter applique spf-filter-loading sur le body pendant
   le chargement. Quand le thème recharge via AJAX (changement
   de page), Smart Filter ne retire pas toujours cette classe,
   laissant les produits invisibles (opacity:0).
   Ce fix force le retrait de la classe après chaque reload.
   ============================================================ */
(function() {
  'use strict';

  function clearSmartFilterLoading() {
    // Retirer la classe de chargement Smart Filter
    document.body.classList.remove('spf-filter-loading');
    // Forcer la visibilité des produits
    var products = document.querySelectorAll('#gf-products > *, [data-globo-filter-items] > *');
    products.forEach(function(el) {
      el.style.visibility = '';
      el.style.opacity = '';
    });
  }

  // Au chargement natif thème (changement page/filtre)
  document.addEventListener('theme:loading:end', function() {
    // Délai court pour laisser le DOM se mettre à jour
    setTimeout(clearSmartFilterLoading, 100);
    setTimeout(clearSmartFilterLoading, 500);
  });

  // Aussi au chargement initial de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(clearSmartFilterLoading, 800);
    });
  } else {
    setTimeout(clearSmartFilterLoading, 800);
  }
})();
